import {SET_LANGUAGE, UPDATE_CURRENT_TIME, START_DRIVING, PAUSE_DRIVING, SET_VIDEO_DURATION, SEEK_VIDEO, GO_TO_STORY, FIND_STORY, OPEN_MENU, OPEN_STORY, START_OVER, START_TRIP, MUTE_AUDIO} from '../actions/timeline';

import timeline from '../../data/timeline.js';
import timelineNL from '../../data/nl/timeline.js';

const defaultState = {
    data: timeline,
    showStory: false,
    storyIsOpen: false,
    isDriving: false,
    currentTime: 0,
    currentTimePerSecond: 0,
    videoDuration: 0,
    seekVideo: false,
    isMenuOpen: false,
    tripStarted: false,
    audioMuted: false
};

function timelineReducer(state = defaultState, action) {

    switch(action.type) {
        case UPDATE_CURRENT_TIME: {
            const currentTime = parseInt(action.payload, 10);

            return {
                ...state,
                currentTimePerSecond: currentTime,
                currentTime: action.payload
            };
        }

        case FIND_STORY: {
            const currentTime = parseInt(action.payload, 10);

            // Call only once per second
            if (currentTime === state.currentTimePerSecond) return state;

            // Find story
            const story = state.data.find((item) => {
                return item.time === currentTime;
            });

            // Show story
            if (story && story.type === "story" && story.time !== state.showStory.time) {
                return {
                    ...state,
                    showStory: story,
                    isDriving: false
                };
            }

            // Show annotation
            if (story && story.type === "annotation") {
                return {
                    ...state,
                    showStory: story
                };
            }

            // Hide annotations after X amount of seconds (showTime)
            if (state.showStory.type === "annotation" && (currentTime - state.showStory.time) > state.showStory.showTime) return {
                ...state,
                showStory: false
            };

            // Hide story after X amount of seconds
            if (state.showStory.type === "story" && (currentTime - state.showStory.time) > 1) {
                return {
                    ...state,
                    showStory: false
                };
            }

            return state;
        }

        case START_DRIVING:
            return {
                ...state,
                isDriving: true
            };

        case PAUSE_DRIVING:
            return {
                ...state,
                isDriving: false
            };

        case START_TRIP:
            return {
                ...state,
                tripStarted: true,
                isDriving: true
            };

        case START_OVER:
            return {
                ...state,
                seekVideo: 0,
                isDriving: false,
                tripStarted: false
            };

        case SET_VIDEO_DURATION:
            return {
                ...state,
                videoDuration: action.payload
            };

        case SEEK_VIDEO:
            return {
                ...state,
                seekVideo: action.payload
            };

        case GO_TO_STORY:
            return {
                ...state,
                showStory: action.payload,
                isDriving: false
            };

        case OPEN_STORY:
            return {
                ...state,
                storyIsOpen: action.payload
            };

        case OPEN_MENU:
            return {
                ...state,
                isMenuOpen: action.payload
            };

        case MUTE_AUDIO:
            return {
                ...state,
                audioMuted: action.payload
            };

        case SET_LANGUAGE:
            // Make language en / nl
            const language = action.payload;
            const {showStory} = state;

            const timelineTranslation = language === "nl" ? timelineNL : timeline;

            const showStoryTranslation = showStory && showStory.type === "story" ? timelineTranslation.find((story) => {
                return story.type === "story" && showStory.link.url.split('/').pop() === story.link.url.split('/').pop(); // TODO: add slug or id in data, instead of pop
            }) : false;

            return {
                ...state,
                data: timelineTranslation,
                language: language === "nl" ? "nl" : "",
                showStory: showStoryTranslation
            };

        default:

            return state;
    }
}

export default timelineReducer;


// WEBPACK FOOTER //
// ./src/state/reducers/timeline.js